// extracted by mini-css-extract-plugin
module.exports = {"smallPadding":"blog-list-module--small-padding--3fJyG","pagination":"blog-list-module--pagination--18CoH","pageLink":"blog-list-module--page-link--3cKPc"};